import cn from "classnames";
import React from "react";
import OrderCard from "./OrderCard";

function AllShipmentsList ({
  data,
  selectedRef,
  handleShipmentClick,
  selectedShipmentIds,
  children,
  selectedShipments,
}) {
  return (
    <>
      {data?.map((shipment) => (
        <OrderCard
          selectedRef={selectedRef}
          key={shipment?.id}
          data={shipment}
          onClick={(shipment) => handleShipmentClick(shipment)}
          selectedShipmentIds={selectedShipmentIds}
          selectedShipments={selectedShipments}
        />
      ))}
      {children}
    </>
  );
}

export default React.memo(AllShipmentsList);
